import { forwardRef, MouseEventHandler } from "react";

import { useChatClass } from "../../theme";
import { Icon } from "../Icon";
import { ButtonContainer } from "./styled";

export interface CarouselButtonProps {
  /** The end of the container where the button will be rendered.*/
  alignment: "left" | "right";
  /** If true then the button will be visible, otherwise hidden */
  visible: boolean;
  /** A click handler for the button. */
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

/** A button used to scroll to the previous or next Card in a Carousel */
export const CarouselButton = forwardRef<HTMLElement, CarouselButtonProps>(
  ({ onClick, alignment, visible }, ref) => {
    const chatClass = useChatClass();
    return (
      <ButtonContainer
        ref={ref}
        $alignment={alignment}
        $visible={visible}
        onClick={onClick}
        className={chatClass("carousel-button")}
      >
        <Icon name="large-arrow-left" size={16} />
      </ButtonContainer>
    );
  },
);
